<template>
  <div class="animated fadeIn">
    <div v-if="initializing" class="text-center">
      <font-awesome-icon spin icon="circle-notch" class="text-moremuted display-2"/>
    </div>
    
    <template v-else>
      <item
        v-for="(item, index) in model"
        :key="item.id"
        :ref="`item${index}`"
        :value="item"
        @remove="remove"
      />

      <b-btn
        size="sm"
        class="mb-3"
        variant="primary"
        :title="$t('shared.add')"
        v-b-tooltip
        @click="add"
      >
        <font-awesome-icon icon="plus" fixed-width class="align-middle"/>
      </b-btn>

      <b-card bg-variant="light">
        <b-btn :disabled="progressing" @click.prevent="submit" variant="success">
          <font-awesome-icon
            :icon="progressing ? 'cog' : 'check'"
            :spin="progressing"
            class="align-middle"
            :class="{'mr-1': $dir.ltr, 'ml-1': $dir.rtl}"
          />
          {{ $t('shared.save') }}
        </b-btn>
      </b-card>
    </template>
  </div>
</template>

<script>
import Breadcrumb from '@/mixins/breadcrumb'
import Item from './Item'

export default {
  name: 'Contacts',
  mixins: [Breadcrumb],
  components: {
    Item
  },
  data () {
    return {
      initializing: true,
      progressing: false,
      model: null
    }
  },
  mounted () {
    this.setBreadcrumb()
    this.getModel()
    .then(() => {
      this.initializing = false
    })
    .catch(err => {
      this.fail(err)
      this.goto('/account/profile')
    })
  },
  methods: {
    setBreadcrumb () {
      const items = []
      let path = ''

      path += '/account'
      items.push({ path, text: this.$t('nav.account') })

      path += '/profile/contacts'
      items.push({ path, text: this.$t('couriers.contacts.contacts') })

      this.commitBreadcrumb(items)
    },
    getModel () {
      return this.$api.account.getContacts(true)
      .then(res => {
        this.model = res

        if (!this.model || !this.model.length) {
          this.model = []
        } else {
          this.model.forEach(item => {
            if (item.fields) {
              if (item.fields.phoneNumbers && item.fields.phoneNumbers.length) {
                item.fields.phoneNumbers.map(i => {
                  i.id = String(Math.floor(Math.random() * 99999999))
                  return i
                })
              }
              if (item.fields.emails && item.fields.emails.length) {
                item.fields.emails.map(i => {
                  i.id = String(Math.floor(Math.random() * 99999999))
                  return i
                })
              }
              if (item.fields.websites && item.fields.websites.length) {
                item.fields.websites.map(i => {
                  i.id = String(Math.floor(Math.random() * 99999999))
                  return i
                })
              }
              if (item.fields.addresses && item.fields.addresses.length) {
                item.fields.addresses.map(i => {
                  i.id = String(Math.floor(Math.random() * 99999999))
                  return i
                })
              }
            }
          })
        }
      })
    },
    add () {
      const item = {
        id: -String(Math.floor(Math.random() * 99999999)),
        firstName: null,
        lastName: null,
        position: null,
        gender: null,
        birthday: null,
        fields: {
          phoneNumbers: [],
          emails: [],
          websites: [],
          addresses: [],
          notes: null
        }
      }
      this.model.push(item)
    },
    remove (itemId) {
      this.model = this.model.filter(i => i.id !== itemId)
    },
    submit () {
      this.validateAll()
      .then(proceed => {
        if (proceed) {
          this.$api.account.updateContacts(this.model, true)
          .then(() => {
            this.$showSuccess(this.$t('account.profileUpdated'))
          })
          .catch(this.fail)
        }
      })
    },
    validateAll () {
      const validates = []
      this.model.map((item, i) => {
        validates.push(this.$refs[`item${i}`][0].validateAll())
        validates.push(this.$refs[`item${i}`][0].validateFields())
      })
      return Promise.all(validates).then(all => {
        return all.every(v => v)
      })
    }
  }
}
</script>